export const INCORPORATION_STAGES = [
  'order_received',
  'documents_review',
  'sent_to_registry',
  'company_registered',
  'documents_available'
] as const;

export type IncorporationStageKey = (typeof INCORPORATION_STAGES)[number];

export type IncorporationStageStatus = 'completed' | 'in_progress' | 'waiting_customer' | 'not_started';

export type IncorporationHistoryType =
  | 'stage_advanced'
  | 'pendency_opened'
  | 'document_sent'
  | 'migrated_from_legacy';

export interface IncorporationStage {
  key: IncorporationStageKey;
  status: IncorporationStageStatus;
  completedAt: string | null;
}

export interface IncorporationPendency {
  id: number;
  stageKey: IncorporationStageKey;
  description: string;
  createdAt: string;
  resolvedAt: string | null;
}

export interface IncorporationHistoryEntry {
  id: string;
  at: string;
  by: string;
  type: IncorporationHistoryType;
  stageKey: IncorporationStageKey;
  note?: string;
}

export interface IncorporationTracking {
  companyId: string;
  jurisdiction: string;
  currentStep: IncorporationStageKey | null;
  finishedAt: string | null;
  stages: IncorporationStage[];
  pendencies: IncorporationPendency[];
  history: IncorporationHistoryEntry[];
}

export interface IncorporationCompanyRef {
  id: number | string;
  status?: string;
  jurisdiction?: unknown;
  name?: string;
  created_at?: string;
  updated_at?: string;
  type?: string;
}
